module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_c('span', {
    staticClass: "italics _idGenCharOverride-1"
  }, [_vm._v("For Stephanie and Max, my Sea and Sky.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb0ed14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0003.vue
// module id = 69
// module chunks = 0